export default "__VITE_ASSET__DzR53oJh__"